import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { dataStarProgramsBaseUrl } from '../index';
import { ProgramsUIProvider } from './ProgramsUIProvider';
import { ProgramsCard } from './ProgramsCard';
import ProgramEditDialog from './program-add-edit-dialog/ProgramEditDialog';
import ProgramViewDialog from './program-view-dialog/ProgramViewDialog';
import { ProgramUpdateStatusDialog } from './program-update-status-dialog/ProgramUpdateStatusDialog';
import { setProgramFilters, uncheckAllPrograms } from '../redux/actions';
import { useDispatch } from 'react-redux';

export function ProgramsPage({ history, match }) {
  const dispatch = useDispatch();

  //clean up
  React.useEffect(() => () => dispatch(uncheckAllPrograms()), []);

  const programsUIEvents = {
    openViewProgramsDialog: (id) => {
      history.push(`${dataStarProgramsBaseUrl}/${id}/view`);
    },
    openNewProgramsDialog: () => {
      history.push(`${dataStarProgramsBaseUrl}/new`);
    },
    openEditProgramsDialog: (id) => {
      history.push(`${dataStarProgramsBaseUrl}/${id}/edit`);
    },
    openDeleteProgramsDialog: (id) => {
      history.push(`${dataStarProgramsBaseUrl}/${id}/delete`);
    },
    openUpdateStatusDialog: () => {
      history.push(`${dataStarProgramsBaseUrl}/update-status`);
    },
  };

  return (
    <ProgramsUIProvider programsUIEvents={programsUIEvents}>
      <Switch>
        <Route path={`${dataStarProgramsBaseUrl}/new`}>
          {({ history, match }) => (
            <ProgramEditDialog
              show={match != null}
              isEdit={false}
              onHide={() => {
                dispatch(setProgramFilters());
                history.push(dataStarProgramsBaseUrl);
              }}
            />
          )}
        </Route>
        <Route path={`${dataStarProgramsBaseUrl}/:id/edit`}>
          {({ history, match }) => (
            <ProgramEditDialog
              show={match != null}
              isEdit={true}
              id={match?.params?.id}
              onHide={() => {
                dispatch(setProgramFilters());
                history.push(dataStarProgramsBaseUrl);
              }}
            />
          )}
        </Route>
        <Route path={`${dataStarProgramsBaseUrl}/:id/view`}>
          {({ history, match }) => (
            <ProgramViewDialog
              show={match != null}
              id={match?.params?.id}
              onHide={() => {
                history.push(dataStarProgramsBaseUrl);
              }}
            />
          )}
        </Route>
        <Route path={`${dataStarProgramsBaseUrl}/update-status`}>
          {({ history, match }) => (
            <ProgramUpdateStatusDialog
              show={match != null}
              onHide={() => {
                dispatch(setProgramFilters());
                history.push(dataStarProgramsBaseUrl);
              }}
            />
          )}
        </Route>
      </Switch>
      <ProgramsCard />
    </ProgramsUIProvider>
  );
}
